export const lv03 = 'EPSG:21781';
export const lv95 = 'EPSG:2056';
